import { MonthlySchedule, PaymentType } from "../../../../generated/graphql"

type CourseWithPaymentOptions =
    | {
          paymentType?: PaymentType | null
          allowUpFrontPayment?: boolean | null
          allowMonthlyPayment?: boolean | null
          allowMolliePayment?: boolean | null
          monthlySchedule?: MonthlySchedule | null
      }
    | null
    | undefined

// Darf der Kunde bei diesem Kurs zwischen Vorkasse und monatlicher Zahlung wählen? Bei Online-Zahlung per Mollie
// rechnet der Server immer mit Vorkasse. Ein individueller Ratenplan auf einem Kurs, der nicht monatlich ist, enthält
// meist nur die Vorkasse-Rate; „Monatlich“ ergäbe dort eine einzige Rate oder einen Rechenfehler.
export const courseOffersPaymentTypeChoice = (course: CourseWithPaymentOptions): boolean =>
    course?.allowUpFrontPayment === true &&
    course?.allowMonthlyPayment === true &&
    course?.allowMolliePayment !== true &&
    !(course?.monthlySchedule === MonthlySchedule.Custom && course?.paymentType !== PaymentType.Monthly)

// Zahlweise, mit der Preview und Buchung rechnen: die gewählte, wenn der Kurs die Wahl anbietet (gleiche Freigabe
// wie im Server, booking.endUserPolicy.ts), sonst die Standard-Zahlweise des Kurses. Ein Wert aus einem anderen
// Kurs oder aus der Zeit vor einer Kursänderung fällt so auf den Standard zurück.
export const resolvePaymentTypeChoice = (requested: PaymentType | null | undefined, course: CourseWithPaymentOptions): PaymentType | null | undefined =>
    courseOffersPaymentTypeChoice(course) && (requested === PaymentType.PrePaid || requested === PaymentType.Monthly) ? requested : course?.paymentType
